import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timeline2',
  templateUrl: './timeline2.component.html',
  styleUrls: ['./timeline2.component.scss']
})
export class Timeline2Component implements OnInit {

  rounds: any = [
    {
      title: 'REGISTRATION'
    },
    {
      title: 'ZONALS'
    },
    {
      title: 'BUSINESS MODEL ROUND'
    },
    {
      title: 'FINALE'
    }
  ]
  dataRoadmap: any = [
    {
        id: 1,
        date: '1st August to 17th September',
        title: 'Registration Form Deadline',
        class: 'left',
        content: 'Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.',
        list : [
            {
                id: 1,
                text: 'Befriending & Chat Functions',
            },
            {
                id: 2,
                text: 'Challenging Feature',
            },
            {
                id: 3,
                text: 'Corsair Wheel',
            },
            {
                id: 4,
                text: 'Mobile Version Launch',
            },
        ]
    
    },
    {
        id: 2,
        date: '1st August to 17th September',
        title: 'Registration Form Deadline',
        class: 'right',
        content: 'Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.',
        list : [
            {
                id: 1,
                text: 'Befriending & Chat Functions',
            },
            {
                id: 2,
                text: 'Challenging Feature',
            },
            {
                id: 3,
                text: 'Corsair Wheel',
            },
            {
                id: 4,
                text: 'Mobile Version Launch',
            },
        ]
    
    },  
    {
        id: 3,
        date: '1st August to 17th September',
        title: 'Registration Form Deadline',
        class: 'left',
        content: 'Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.',
        list : [
            {
                id: 1,
                text: 'Befriending & Chat Functions',
            },
            {
                id: 2,
                text: 'Challenging Feature',
            },
            {
                id: 3,
                text: 'Corsair Wheel',
            },
            {
                id: 4,
                text: 'Mobile Version Launch',
            },
        ]
    
    },      
    {
        id: 4,
        date: '1st August to 17th September',
        title: 'Registration Form Deadline',
        class: 'right',
        content: 'Eureka! opens its applications for all entrepreneurs on 1st August. Register by filling your details and logging in to the Eureka! dashboard. Add your co-founders and fill your startup idea details.',
        list : [
            {
                id: 1,
                text: 'Befriending & Chat Functions',
            },
            {
                id: 2,
                text: 'Challenging Feature',
            },
            {
                id: 3,
                text: 'Corsair Wheel',
            },
            {
                id: 4,
                text: 'Mobile Version Launch',
            },
        ]
    
    },    
  ];
  constructor() { }

  ngOnInit(): void {
  }
}
